'use strict';
module.exports = require('./Row.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/row/index.js
// module id = 381
// module chunks = 1